import { base } from './';
import {
  EventCreateType,
  EventUpdateType,
  IEvent,
  IOrganization,
  SearchEventQueryType,
} from 'types';

type PatchEventStatusParam = { id: number; eventStatus: IEvent['eventStatus'] };

const PATH = '/events';
const get = (id: string) => base.get(`${PATH}/${id}`);

const getAll = (filter: SearchEventQueryType) =>
  base.get(PATH, { params: { ...filter } });

const post = (data: EventCreateType) => base.post(PATH, data);

const put = ({ id, ...data }: EventUpdateType) =>
  base.put(`${PATH}/${id}`, data);

const getPartner = (id: string) => base.get(`${PATH}/${id}/partners`);

const putPartners = ({
  id,
  partnerIds,
}: {
  id: number;
  partnerIds: number[];
}) => base.put(`${PATH}/${id}/partners`, partnerIds);

const getOrganizations = (id: number) =>
  base.get<IOrganization[]>(`${PATH}/${id}/organizations`);

const putOrganizations = ({
  id,
  organizationIds,
  organizationSortOrder,
}: {
  id: number;
  organizationIds: number[];
  organizationSortOrder?: IEvent['organizationSortOrder'];
}) =>
  base.put(`${PATH}/${id}/organizations`, {
    organizationIds,
    organizationSortOrder,
  });

const getContents = (id: number) => base.get(`${PATH}/${id}/contents`);

const putContents = ({
  id,
  contentIds,
  contentSortOrder,
}: {
  id: number;
  contentIds: number[];
  contentSortOrder?: IEvent['contentSortOrder'];
}) => base.put(`${PATH}/${id}/contents`, { contentIds, contentSortOrder });

const patchStatus = ({ id, eventStatus }: PatchEventStatusParam) =>
  base.patch(`${PATH}/${id}/status`, { eventStatus });

const deleteEvent = (id: number) => base.delete(`${PATH}/${id}`);

export {
  get,
  getAll,
  post,
  put,
  getPartner,
  putPartners,
  getOrganizations,
  putOrganizations,
  getContents,
  putContents,
  patchStatus,
  deleteEvent,
};
